/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react'
import { Calendar, dayjsLocalizer } from 'react-big-calendar'
import dayjs from 'dayjs'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import '../../Styles/ViewMeeting.css'
import { Accordion, AccordionDetails, AccordionSummary, Box, Card, CardActions, CardContent, CardHeader, Divider, Grid, IconButton, Menu, MenuItem, Paper, Typography, styled } from '@mui/material'
import event from '../../Entities/events'
import CustomToolbar from './CustomToolbar'
import { IoChevronDown, IoAdd } from 'react-icons/io5'
import { BiSolidCopy } from 'react-icons/bi'
import { Checkbox } from '../../Common/ui/checkbox'
import ToggleSwitch from '../../Common/ui/ToggleSwitch'
import * as RoutePaths from '../../Entities/RoutePath'
import { RxExternalLink } from 'react-icons/rx'
import 'react-day-picker/dist/style.css'
import useCustomNavigate from '../../Common/ui/Navigate'
import { DayPicker } from 'react-day-picker'
import { useTranslation } from 'react-i18next'
import { cn } from '../../lib/utils'
import { useMeetingStore } from './Store/MeetingStore'
import PropTypes from 'prop-types'
import { LuCalendarDays } from 'react-icons/lu'
import * as MeetingTypes from '../../Entities/MeetingTypes'
import { SubmitModal } from '../../Components/Onboarding/SubmitModal'
import { INITIATE } from 'src/Entities/CommonEntities'

const localizer = dayjsLocalizer(dayjs)

const CustomEvent = ({ event, handleEventClick, level, setLevel }) => {
    const handClickEventSlot = (e) => {
        if (event?.event?.bgColor === level?.bgColor) {
            handleEventClick(event?.event, e)
        }
    }

    const handClickEventCalendar = (el) => {
        if (event?.event?.title === level?.title) {
            setLevel({ bgColor: '', title: '' })
        } else {
            setLevel({ ...level, bgColor: el?.bgColor, title: el?.title })
        }
    }
    return (
        <Card sx={{ width: '100%', height: '100%' }}>
            {event?.event?.type === MeetingTypes.MEETING
                ? <Box onClick={handClickEventSlot} sx={{ color: event?.event?.bgColor !== level?.bgColor && level?.bgColor !== '' && level?.bgColor !== '' && 'hsl(var(--grey))', backgroundColor: event?.event?.bgColor !== level?.bgColor && level?.bgColor !== '' && level?.bgColor !== '' && 'hsl(var(--popover))', width: '100%', cursor: event?.event?.bgColor !== level?.bgColor && level?.bgColor !== '' && 'default', border: event?.event?.bgColor === level?.bgColor && `3px solid ${event?.event?.bgColor}`, borderRadius: '8px', height: '100%', p: 0.5 }}>
                    <Box display="flex" sx={{ width: '100%', height: '100%' }} alignItems="center">
                        <Box
                            sx={{ width: '10px' }}
                            height={'100%'}
                            borderRadius="20px"
                            bgcolor={event?.event?.bgColor}
                        >
                        </Box>
                        <Box sx={{ width: '90%', paddingTop: 0.5, paddingLeft: 1, display: 'flex', flexDirection: 'column', height: '100%' }}>
                            <Typography class="event-title" style={{ width: '100vh' }} >{event?.event?.title}</Typography>
                            <Typography class="event-time" style={{ display: 'flex', flexDirection: 'row' }}>
                                <span>{localizer.format(event?.event?.start, 'LT')}</span> -
                                <span>{localizer.format(event?.event?.end, 'LT')}</span>
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                : event?.event?.type === MeetingTypes.HOLIDAYS
                    ? <div className={'rbc-event-content holiday-event'}>
                        <Box sx={{ width: '100%', borderRadius: '2px', background: event?.event?.bgColor, height: '100%', p: 0.5 }}>
                            <Box display="flex" sx={{ width: '100%', height: '100%' }} alignItems="center">
                                <Box sx={{ width: '90%', paddingLeft: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', height: '300px' }}>
                                </Box>
                            </Box>
                        </Box>
                    </div>
                    : <Box sx={{ width: '100%', borderRadius: '2px', backgroundColor: event?.event?.bgColor, height: '100%', p: 0.5, cursor: event?.event?.bgColor !== level?.bgColor && level?.bgColor !== '' ? 'default' : 'pointer', pointerEvents: event?.event?.bgColor !== level?.bgColor && level?.bgColor !== '' ? 'none' : 'auto', opacity: event?.event?.bgColor !== level?.bgColor && level?.bgColor !== '' ? 0.5 : 1 }}>
                        <Box display="flex" sx={{ width: '100%', height: '100%' }} alignItems="center">
                            <Box sx={{ width: '100%', paddingLeft: 1, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: '100%' }}>
                                <Typography class="event-title" style={{ color: 'hsl(var(--accent))' }} onClick={handClickEventSlot} >{event?.event?.title}</Typography>
                                <Typography class="event-title" style={{ color: 'hsl(var(--accent))' }} onClick={() => handClickEventCalendar(event?.event)} ><LuCalendarDays /></Typography>
                            </Box>
                        </Box>
                    </Box>}
        </Card>
    )
}

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : 'hsl(var(--accent))',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary
}))

const eventMeeting = [
    {
        type: 'Event',
        isToggleOn: true,
        eventTitle: [
            { title: 'Bank Holidays', bgColor: 'lightGreen', isSelected: true },
            { title: 'General Holidays', bgColor: '#007876', isSelected: true },
            { title: 'Risk', bgColor: '#be3144', isSelected: true },
            { title: 'Compliance', bgColor: '#4b0082', isSelected: true },
            { title: 'Issue', bgColor: '#f19e38', isSelected: true }
        ]
    },
    {
        type: 'Meeting',
        isToggleOn: true,
        eventTitle: [
            { title: 'Governance', bgColor: '#3371ff', isSelected: true },
            { title: 'Risk', bgColor: '#be3144', isSelected: true },
            { title: 'Compliance', bgColor: '#4b0082', isSelected: true },
            { title: 'Issue', bgColor: '#f19e38', isSelected: true },
            { title: 'Annual General', bgColor: '#1b81b3', isSelected: true },
            { title: 'Board', bgColor: '#00a2a1', isSelected: true },
            { title: 'Other', bgColor: '#444444', isSelected: true }
        ]
    }
]

const ViewMeetingContainer = () => {
    const { t } = useTranslation()
    const { getDate } = useMeetingStore()
    const customNavigate = useCustomNavigate()
    const [ Events, setEvents ] = useState(event)
    const [ eventAndMeetingData, setEventAndMeetingData ] = useState(eventMeeting)
    const [ expandedPanel, setExpandedPanel ] = useState({ panel0: 'panel0', panel1: 'panel1' })
    const [ anchorPosition, setAnchorPosition ] = useState(null)
    const [ eventSlotPosition, setEventSlotPosition ] = useState(null)
    const [ level, setLevel ] = useState({ bgColor: '', title: '' })
    const [ showSubmitModal, setShowSubmitModal ] = useState(false)
    useEffect(() => {
        setEvents(event)
        setShowSubmitModal(true)
    }, [])

    const onCheckboxValueChange = (value, keyEl, data) => {
        setEventAndMeetingData(eventAndMeetingData?.map((filterData) => {
            if (filterData.type === data.type) {
                return {
                    ...filterData,
                    eventTitle: filterData?.eventTitle?.map((filterChild) => {
                        if (filterChild.title === keyEl?.title) {
                            return { ...filterChild, isSelected: keyEl?.isSelected !== true }
                        } else return filterChild
                    })
                }
            } else return filterData
        }))

        if (!value) {
            setEvents(Events?.filter((eventDt) => {
                if (eventDt?.type?.toLocaleLowerCase() === data?.type?.toLocaleLowerCase()) {
                    return eventDt?.bgColor?.toLocaleLowerCase() !== keyEl?.bgColor?.toLocaleLowerCase()
                } else return eventDt
            }))
        } else {
            setEvents([ ...Events, ...event?.filter((eventDt) => {
                if (eventDt?.type?.toLocaleLowerCase() === data?.type?.toLocaleLowerCase()) {
                    return eventDt?.bgColor?.toLocaleLowerCase() === keyEl?.bgColor?.toLocaleLowerCase()
                }
            }) ])
        }
    }

    const handleChange = (panel) => {
        if (panel === 'panel0') {
            setExpandedPanel({ ...expandedPanel, panel0: expandedPanel?.panel0 === panel ? null : panel })
        }
        if (panel === 'panel1') {
            setExpandedPanel({ ...expandedPanel, panel1: expandedPanel?.panel1 === panel ? null : panel })
        }
    }

    const handleSelectSlot = (event) => {
        setAnchorPosition({ left: event?.box?.clientX, top: event?.box?.clientY })
    }

    const handleCloseMenu = (name) => {
        setAnchorPosition(null)
        if (name === RoutePaths.RISK.NAME) {
            customNavigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.RISK.URI + '/' + INITIATE, RoutePaths.RISK.NAME)
        }
    }

    const handleEventClick = (event, e) => {
        if (event?.type === MeetingTypes.MEETING) {
            setEventSlotPosition({ left: e.clientX, top: e.clientY })
        }
        if (event?.type === MeetingTypes.EVENT) {
            setEventSlotPosition({ left: e.clientX, top: e.clientY, type: event?.type })
        }
    }

    const handleCloseEventSlotMenu = () => {
        customNavigate(`${RoutePaths.MAIN_CONTAINER.MAIN}${RoutePaths.CALENDAR.URI}/view-meeting/${567}`, RoutePaths.CALENDAR.NAME)
        setEventSlotPosition(null)
    }

    const handleToggle = (value, data) => {
        setEventAndMeetingData(eventAndMeetingData?.map((dt) => {
            if (dt?.type === data?.type) {
                return { ...dt, isToggleOn: value }
            } else return dt
        }))

        if (!value) {
            setEvents(Events?.filter((eventMeetingDt) => eventMeetingDt?.type?.toLocaleLowerCase() !== data?.type?.toLocaleLowerCase()))
        } else {
            setEvents([ ...Events, ...event?.filter((eventMeetingDt) => eventMeetingDt?.type?.toLocaleLowerCase() === data?.type?.toLocaleLowerCase()) ])
        }
    }

    return (
        <Typography class='view-meeting-container' >
            <SubmitModal isOpen={showSubmitModal} setShowSubmitModal={setShowSubmitModal} />
            <Grid container sx={{ height: '100%' }} >
                <Grid item sx={{ p: '1% 0% 1% 1%', height: '100%', backgroundColor: '#f7f8fd', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }} xs={2.5}>
                    <Item sx={{ height: '45%', width: '100%', p: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
                        <DayPicker
                            showOutsideDays={true}
                            style={{ backgroundColor: '#fff' }}
                            classNames={{
                                months: 'flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
                                month: 'space-y-3',
                                caption_start: 'is-start',
                                caption_between: 'is-between',
                                caption_end: 'is-end',
                                caption: 'flex justify-center pt-1 relative items-center gap-1',
                                caption_label: 'flex h-7 text-sm font-medium justify-center items-center grow [.is-multiple_&]:flex',
                                caption_dropdowns: 'flex justify-center grow dropdowns pl-7 pr-8',
                                multiple_months: 'is-multiple',
                                vhidden: 'hidden [.is-between_&]:flex [.is-end_&]:flex [.is-start.is-end_&]:hidden',
                                nav: "flex items-center [&:has([name='previous-month'])]:order-first [&:has([name='next-month'])]:order-last",
                                nav_button: cn(
                                    'h-6 w-6 bg-transparent p-0 text-primary'
                                ),
                                nav_button_previous: 'absolute left-1',
                                nav_button_next: 'absolute right-1',
                                table: 'w-full border-collapse space-y-1',
                                head_row: 'flex',
                                head_cell: 'text-primary rounded-md w-8 font-normal text-[0.8rem]',
                                row: 'flex w-full mt-2',
                                cell: cn(
                                    'relative p-0 text-center text-sm focus-within:relative focus-within:z-20 [&:has([aria-selected])]:bg-primary-foreground',
                                    '[&:has(>.day-range-end)]:rounded-r-full [&:has(>.day-range-start)]:rounded-l-full first:[&:has([aria-selected])]:rounded-l-full last:[&:has([aria-selected])]:rounded-r-full'
                                ),
                                day: cn(
                                    'h-8 w-8 p-0 font-normal aria-selected:opacity-100',
                                    'bg-primary rounded-full'
                                ),
                                day_selected:
                                'aria-selected:bg-primary-foreground',
                                day_range_middle: 'aria-selected:bg-primary-foreground rounded-[0px] aria-selected:text-primary',
                                day_hidden: 'invisible'
                            }}
                            mode="range"
                            month={dayjs(getDate?.from).format('MMMM YYYY')}
                            selected={getDate}
                        />
                    </Item>
                    <div style={{ backgroundColor: '#f7f8fd', height: '53%', overflow: 'scroll' }}>
                        {eventAndMeetingData?.map((data, index) => <Accordion
                            key={index}
                            expanded={expandedPanel[`panel${index}`] === `panel${index}`}
                            defaultExpanded={true}
                            sx={{ boxShadow: 'none', backgroundColor: '#f7f8fd' }}
                        >
                            <AccordionSummary
                                expandIcon={<IoChevronDown onClick={() => handleChange(`panel${index}`)} />}
                                aria-controls={`panel${index}-content`}
                                id={`panel${index}-header`}
                            >
                                <Typography sx={{ display: 'flex', flexDirection: 'row', width: '80%', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography>{t(data.type)}</Typography>
                                    <ToggleSwitch isChecked={data?.isToggleOn} onChange={(value) => handleToggle(value, data)} />
                                    {index === 1 && <IoAdd />}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {data.eventTitle.map((el, key) => (
                                    <div key={key} className='flex mt-auto mb-4'>
                                        <Checkbox
                                            checked={el.isSelected}
                                            onCheckedChange={(e) => onCheckboxValueChange(e, el, data)}
                                            color={el.bgColor}
                                            className={el.isSelected ? 'my-auto border-none' : 'my-auto'}
                                        />
                                        {el.title && <label className='grc-label ml-2'>{el.title}</label>}
                                    </div>
                                ))}
                            </AccordionDetails>
                            <Divider />
                        </Accordion>)}
                    </div>
                </Grid>
                <Grid item sx={{ p: '1% 1% 1% 1%', height: '100%' }} xs={9.5}>
                    <Item style={{ height: '100%', backgroundColor: '#fff' }}>
                        <Calendar
                            localizer={localizer}
                            selectable={true}
                            events={Events}
                            defaultView="week"
                            views={[ 'day', 'week', 'month' ]}
                            startAccessor="start"
                            endAccessor="end"
                            onSelectSlot={handleSelectSlot}
                            dayLayoutAlgorithm="no-overlap"
                            components={{
                                event: (value) => {
                                    return (
                                        <CustomEvent
                                            handleEventClick={handleEventClick}
                                            setEventSlotPosition={setEventSlotPosition}
                                            level={level}
                                            setLevel={setLevel}
                                            event={value}
                                        />
                                    )
                                },
                                toolbar: CustomToolbar
                            }}
                            style={{ height: '100%' }}
                            popup
                        />
                        {anchorPosition && (
                            <Menu
                                anchorReference="anchorPosition"
                                anchorPosition={anchorPosition}
                                open={Boolean(anchorPosition)}
                                onClose={handleCloseMenu}
                            >
                                <MenuItem onClick={handleCloseMenu}>Governance</MenuItem>
                                <MenuItem onClick={() => handleCloseMenu(RoutePaths.RISK.NAME)}>Risk</MenuItem>
                                <MenuItem onClick={handleCloseMenu}>Compliance</MenuItem>
                                <MenuItem onClick={handleCloseMenu}>Issue</MenuItem>
                                <MenuItem onClick={handleCloseMenu}>Board</MenuItem>
                                <MenuItem onClick={handleCloseMenu}>Anual General</MenuItem>
                                <MenuItem onClick={handleCloseMenu}>Other</MenuItem>
                            </Menu>
                        )}
                        {eventSlotPosition && (
                            <Menu
                                anchorReference="anchorPosition"
                                anchorPosition={{ left: eventSlotPosition?.left, top: eventSlotPosition?.top }}
                                open={Boolean(eventSlotPosition)}
                                onClose={() => setEventSlotPosition(null)}
                            >
                                <Typography sx={{ width: '300px', minWidth: 275 }}>
                                    <CardHeader
                                        title={<Typography style={{ fontSize: '16px', fontWeight: 'bold' }} variant="subtitle1">{'vacancy'}</Typography>}
                                        sx={{
                                            height: '20px',
                                            textAlign: 'center',
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}
                                        action={
                                            <IconButton sx={{
                                                height: '20px',
                                                fontWeight: 'bold',
                                                fontSize: '16px',
                                                color: 'hsl(var(--primary))'
                                            }} onClick={handleCloseEventSlotMenu} aria-label="edit">
                                                <RxExternalLink />
                                            </IconButton>
                                        }
                                    />
                                    <CardContent>
                                        <Box>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    <Typography style={{ fontSize: '12px' }} variant="subtitle1">{'vacancy'}</Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography style={{ fontSize: '12px' }} variant="subtitle1">{'time'}</Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    <Typography style={{ fontSize: '12px' }} variant="subtitle1">{'name'}</Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography style={{ fontSize: '12px' }} variant="subtitle1">{'role'}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                        {eventSlotPosition?.type !== MeetingTypes.EVENT && <Divider />}
                                        {eventSlotPosition?.type !== MeetingTypes.EVENT && <Box>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} >
                                                    <Typography style={{ fontSize: '12px', color: 'hsl(var(--primary))' }} variant="subtitle1">{'Mode'}</Typography>
                                                    <Typography style={{ fontSize: '12px' }} variant="subtitle1">{'Online'}</Typography>
                                                </Grid>
                                                <Grid item xs={12} >
                                                    <Typography style={{ color: 'hsl(var(--primary))', fontSize: '12px' }} variant="subtitle1">{'Meeting Platform'}</Typography>
                                                    <Typography style={{ fontSize: '12px' }} variant="subtitle1">{'Teams'}</Typography>
                                                </Grid>
                                                <Grid item xs={12} >
                                                    <Typography style={{ color: 'hsl(var(--primary))', fontSize: '12px' }} variant="subtitle1">{'Meeting Links'}</Typography>
                                                    <Typography style={{ fontSize: '12px', display: 'flex', flexDirection: 'row', alignItems: 'center' }} variant="subtitle1"><span>{'http://localhost:3000/GRC/settings/view-meeting'}</span><span><BiSolidCopy /></span></Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>}
                                    </CardContent>
                                    <CardActions>
                                    </CardActions>
                                </Typography>
                            </Menu>
                        )}
                    </Item>
                </Grid>
            </Grid>
        </Typography>
    )
}

export default ViewMeetingContainer

CustomEvent.propTypes = {
    event: PropTypes.any,
    handleEventClick: PropTypes.func,
    level: PropTypes.any,
    setLevel: PropTypes.func
}
